import { UPDATE_CONTINUE_WATCHING_ITEMS } from 'app/actions/continueWatching/actions';
import ContinueWatching from './models/ContinueWatching';

export type ContinueWatchingPayload = {
    items: ContinueWatching[];
};

const isContiueWatchingPayload = (payload: any): payload is ContinueWatchingPayload =>
    (payload as ContinueWatchingPayload).items !== undefined;

/**
 * Migration January 2022:
 * Deleted continue watching items will be removed completely from local storage
 */
export const migrateContinueWatchingPayload = (
    payload: ContinueWatchingPayload
): { persistent: boolean; payload: ContinueWatchingPayload } => {
    const result = { ...payload };
    let persistent = false;
    try {
        result.items = result.items.filter((item) => {
            if (item.deleted) {
                persistent = true;
            }

            return !item?.deleted;
        });
        // eslint-disable-next-line no-empty
    } catch (e) {}

    return {
        persistent,
        payload: result,
    };
};

export const migratePayload = (
    type: string,
    payload: unknown
): { persistent?: boolean; payload: unknown } => {
    if (type === UPDATE_CONTINUE_WATCHING_ITEMS && isContiueWatchingPayload(payload)) {
        const migrated = migrateContinueWatchingPayload(payload);

        return { persistent: migrated.persistent, payload: migrated.payload };
    }

    return { payload };
};
